import { CouponType, OrderMethod, PaymentMethod, RefundReason } from '../../../../../../services/exports/Constants';

export default {
  title: 'Bestelinformatie',
  sections: {
    driver_info: 'Chauffeurinfo',
    order_info: 'Bestelinformatie',
    price_info: 'Prijsinformatie',
    adjustments: 'Aanpassingen',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Afhalen',
    [OrderMethod.Delivery]: 'Bezorging',
    [OrderMethod.OnSite]: 'Bestelling aan tafel',
  },
  labels: {
    wolt_support: 'Wolt support telefoonnummer: {{phone_number}}',
    wolt_support_text:
      'Bel Wolt bij vragen over de bestelling, de chauffeur of problemen. Vermeld dat het een <strong>Wolt Drive</strong>-bestelling is',
    dummy_order: 'Testbestelling',
    asap: 'Z.s.m.',
    driver_name: 'Naam chauffeur',
    driver_phone_number: 'Tel. chauffeur',
    pin_code: 'PIN',
    dropoff_pin_code: 'Aflever-PIN',
    original: 'Origineel',
    delivery_fee: 'Bezorgkosten',
    tip: 'Fooi',
    service_fee: 'Online verwerking',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal-kosten',
    },
    promo_applied: {
      default: 'Promo toegepast',
      [CouponType.Reward]: 'Loyaliteitspunten toegepast',
      [CouponType.Cashback]: 'Loyaliteitspunten toegepast',
      [CouponType.PromoCode]: 'Promo toegepast',
      [CouponType.GiftCard]: 'Cadeaukaart toegepast',
    },
    tax: 'Belastingen',
    total: 'Totaal',
    online_payment: 'Klant heeft al betaald in de {{provider}}-app',
    cash_payment: 'Betaling ter plaatse',
    invoice_payment: 'Betaling via factuur',
    old_order: 'Deze bestelling is succesvol afgehandeld',
    pickup_time: 'Afhaaltijd',
    pickup_asap: 'De klant wil zo snel mogelijk afhalen.',
    points_used: 'Deze bestelling bevat een loyaliteitsbeloning van een vaste klant',
    order_note: 'Opmerking bij bestelling:',
    today: 'vandaag',
  },
  schedule: {
    header: 'Gepland voor {{date}}, {{time}}',
    text: 'We herinneren u wanneer het tijd is de bestelling te bereiden',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Verzocht door klant',
    [RefundReason.Reclamation]: 'Reclamatie',
    [RefundReason.CommunicationError]: 'Communicatiefout',
    [RefundReason.Other]: 'Overig',
    [RefundReason.Dispute]: 'Klantgeschil',
    dispute_win: 'Klantgeschil gewonnen',
    null: '',
  },
  toasts: {
    print_one: 'Bezig {{count}} bon af te drukken: Bestelling <strong>#{{orderNumber}}</strong>...',
    print_other: 'Bezig {{count}} bonnen af te drukken: Bestelling <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Terugbetaling geslaagd: Bestelling <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Afdrukken',
    confirm: 'Bevestigen',
    reject: 'Afwijzen',
    refund: 'Terugbetalen',
  },
};
